export enum VerificationState {
  NONE = 'none',
  WEAK = 'weak',
  STRONG = 'strong'
}
